import { AuthLayout } from '~/components/Layouts/AuthLayout';
export const AuthLayoutBackButton = ({
  children,
}: {
  children: JSX.Element | JSX.Element[];
}) => {
  return <AuthLayout hideBackButton={false}>{children}</AuthLayout>;
};
